import PubSub from "underpub-js";
import gsap from 'gsap';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

var HeroBackgroundVideo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-HeroBackgroundVideo',
	};

	$.extend(true, this.options, options);

};

HeroBackgroundVideo.prototype.init = function() {

	var self = this;

	this.childSplit = null;
	this.parentSplit = null;

	this.splitLines();


	PubSub.subscribe("resized", function(){
		self.resplitLines();
	});

	// gsap.set(self.options.$el.find(`.${self.options.baseClass}__heading`), {
	// 	opacity: 1
	// });

	// gsap.to(self.options.$el.find(`.${self.options.baseClass}__heading__lineParent__lineChild`), {
	// 	duration: 0.75,
	// 	delay: 1,
	// 	y: 0,
	// 	stagger: {
	// 		each: 0.25
	// 	}
	// });

	const $button = self.options.$el.find(`.atom-ButtonPrimary`);
	const $buttonBackground = $button.find(`.atom-ButtonPrimary__background`);
	const $buttonInner = $button.find(`.atom-ButtonPrimary__inner`);

	gsap.timeline()
		.to(self.options.$el.find(`.${self.options.baseClass}__backgroundVideo`), {
			duration: 0.9,
			ease: "expo.inOut",
			y: 0,
			scale: 1
		}, .5)
		.to(self.options.$el.find(`.${self.options.baseClass}__contentCover`), {
			duration: 1,
			ease: "expo.inOut",
			bottom: '100%',
		}, .5)
		.set(self.options.$el.find(`.${self.options.baseClass}__heading`), {
			opacity: 1
		}, 1.1)
		.to(self.options.$el.find(`.${self.options.baseClass}__heading__lineParent__lineChild`), {
			duration: 0.6,
			ease: "power2.out",
			y: 0,
			stagger: {
				each: 0.06
			},
		}, 1.1)
		.addLabel("headingComplete")
		.to(self.options.$el.find(`.el-NavBar__logo`), {
			duration: 0.6,
			ease: "power3.out",
			opacity: 1,
			y: 0
		}, "headingComplete-=.4")
		.to(self.options.$el.find(`.el-NavBar__cta`), {
			duration: 0.6,
			ease: "power3.out",
			opacity: 1,
			y: 0
		}, "headingComplete-=.4")
		.call(function(){
			PubSub.publish('NavOverlay:closing');
		}, {}, "headingComplete-=1.5")
		.call(function(){
			PubSub.publish('ContentHeadingWithText.animateIn');
		}, {}, "headingComplete-=.35")
		.to($buttonBackground,
			{
				opacity: 1,
				duration: .25,
				ease: "expo.out",
			},
			"headingComplete+=0.5"
		)
		.to($buttonBackground,
			{
				opacity: 1,
				//width: "100%",
				left: 0,
				right: 0,
				duration: .6,
				ease: "expo.out",
			},
			"<.1"
		)
		.fromTo($buttonInner,
			{
				opacity:0,
				x: -20
			},
			{
				opacity: 1,
				x: 0,
				duration: .4,
				ease: "expo.out",
			},
			"<.2"
		)
		.set(self.options.$el,
			{
				overflow: 'visible'
			}
		);

};

HeroBackgroundVideo.prototype.splitLines = function() {

	var self = this;

	// split text
	this.childSplit = new SplitText(self.options.$el.find(`.${self.options.baseClass}__heading`), { type: "lines", linesClass: `${self.options.baseClass}__heading__lineParent__lineChild` });
	this.parentSplit = new SplitText(self.options.$el.find(`.${self.options.baseClass}__heading`), { type: "lines words", linesClass: `${self.options.baseClass}__heading__lineParent` });

};

HeroBackgroundVideo.prototype.revertSplitLines = function() {

	var self = this;

	// revert in reverse order
	this.parentSplit.revert();
	this.childSplit.revert();

};

HeroBackgroundVideo.prototype.resplitLines = function() {

	var self = this;

	this.revertSplitLines();

	// resplit
	this.childSplit.split();
	this.parentSplit.split();

	gsap.set(self.options.$el.find(`.${self.options.baseClass}__heading__lineParent__lineChild`), {
		y: 0
	});

};

export default HeroBackgroundVideo;
